<script lang="ts" setup>
import OmniDialog from "@/components/omni/OmniDialog.vue";
import type { DispatcherDto } from "@/api/dispatchers/dto/dispatcher.dto";
import { API } from "@/api/api";
import { DialogSize } from "@/constants/dialog";

const api = new API();

const props = defineProps<{
  dispatcher: DispatcherDto;
}>();

const emits = defineEmits<{
  (e: "refresh"): void;
}>();

const showArchiveDialog = defineModel<boolean>("showArchiveDialog", { default: false });
const showUnArchiveDialog = defineModel<boolean>("showUnArchiveDialog", { default: false });

async function archive() {
  console.log("di");
  if (!props.dispatcher.id) {
    return;
  }
  const resp = await api.dispatchers.archiveDispatcher(props.dispatcher.id);
  if (resp.success) {
    showArchiveDialog.value = false;
    emits("refresh");
  }
}

async function unarchive() {
  if (!props.dispatcher.id) {
    return;
  }

  const resp = await api.dispatchers.unarchiveDispatcher(props.dispatcher.id);
  if (resp.success) {
    showUnArchiveDialog.value = false;
    emits("refresh");
  }
}
</script>

<template>
  <omni-dialog
    v-model="showArchiveDialog"
    :size="DialogSize.small"
    persistent
    primary-action-label="Archive"
    title="Archive dispatcher"
    @primary-action:click="archive"
  >
    <div class="my-4">Are you sure want to send {{ dispatcher.name }}’s account to archive?</div>
  </omni-dialog>
  <omni-dialog
    v-model="showUnArchiveDialog"
    :size="DialogSize.small"
    persistent
    primary-action-label="Unarchive"
    title="Unarchive dispatcher"
    @primary-action:click="unarchive"
  >
    <div class="my-4">Are you sure want to return {{ dispatcher.name }}’s account from archive?</div>
  </omni-dialog>
</template>

<style lang="scss" scoped></style>
